import type { BulkOperationSummary } from "../api/types.ts";
import { ACTION_LABELS, getTargetEntity } from "./bulkActionLabels.ts";

export interface BulkTargetProgress {
    done: number;
    total: number;
    entity: string;
}

export function getBulkTargetProgress(summary: BulkOperationSummary): BulkTargetProgress | undefined {
    const targets = summary.itemSummaries.filter(item => !item.skipped && item.action === summary.action);

    if (targets.length === 0) {
        return undefined;
    }

    return targets.reduce<BulkTargetProgress>(
        (progress, item) => {
            progress.done += item.succeededCount + item.failedCount;
            progress.total += item.count;

            return progress;
        },
        { done: 0, total: 0, entity: getTargetEntity(targets, ACTION_LABELS[summary.action].entity) }
    );
}
